import React from 'react';
import {
  NodeKey,
  DecoratorNode,
  $applyNodeReplacement,
  LexicalNode,
  SerializedLexicalNode,
  Spread,
} from 'lexical';
import { DiffHunk } from './DiffHunk';

export type SerializedDiffHunkNode = Spread<
  { diffContent: string },
  SerializedLexicalNode
>;

export class DiffHunkNode extends DecoratorNode<React.ReactNode> {
  __diffContent: string;

  static getType() {
    return 'diff-hunk';
  }

  static clone(node: DiffHunkNode) {
    return new DiffHunkNode(node.__diffContent, node.__key);
  }

  constructor(diffContent: string, key?: NodeKey) {
    super(key);
    this.__diffContent = diffContent;
  }

  getDiffContent(): string {
    return this.getLatest().__diffContent;
  }

  createDOM() {
    const div = document.createElement('div');
    div.setAttribute('data-lexical-diff-hunk', 'true');
    return div;
  }

  updateDOM() {
    return false;
  }

  decorate() {
    return <DiffHunk diffContent={this.__diffContent} nodeKey={this.__key} />;
  }

  isInline(): boolean {
    return false;
  }

  static importJSON(serializedNode: SerializedDiffHunkNode): DiffHunkNode {
    return $applyNodeReplacement(
      new DiffHunkNode(serializedNode.diffContent),
    ) as DiffHunkNode;
  }

  exportJSON(): SerializedDiffHunkNode {
    return {
      ...super.exportJSON(),
      diffContent: this.__diffContent,
      type: 'diff-hunk',
      version: 1,
    };
  }
}

export const $createDiffHunkNode = (diffContent: string) => {
  return $applyNodeReplacement(new DiffHunkNode(diffContent));
};

export const $isDiffHunkNode = (
  node: LexicalNode | null | undefined,
): node is DiffHunkNode => {
  return node instanceof DiffHunkNode;
};
